module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-wrapper",
    class: {
      'open': _vm.openSuggestion
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection),
      expression: "selection"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.selection)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enter.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up.apply(null, arguments)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.selection = $event.target.value
      }, _vm.change],
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu autocomplete-dropdown"
  }, _vm._l((_vm.matches), function(suggestion, index) {
    return _c('li', {
      key: index + '_' + suggestion,
      class: {
        'active': _vm.isActive(index)
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.suggestionClick(index)
        },
        "click": function($event) {
          $event.preventDefault();
          return _vm.suggestionClick(index)
        }
      }
    }, [_c('a', {
      staticClass: "clickable"
    }, [_vm._v(_vm._s(suggestion))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15e00a74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/AutocompleteObject.vue
// module id = 731
// module chunks = 0